import type { CSSProperties } from 'react';
import CheckmarkIconSvg from '../../assets/icons/checkmark.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const CheckmarkIcon: React.FC<IconProps> = ({ size = 16, className = '', style = {}, onClick }) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <CheckmarkIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default CheckmarkIcon;
